import { Button } from '@platform/components';
import {
  ApplicationResultContent,
  ApplicationResultStepper,
} from '../../components/ApplicationResultContent';

const steps = [
  {
    label: 'Application submitted',
  },
  {
    label: 'Application under review',
    active: true,
    content: 'Your Program lead will personally review your application.',
  },
  {
    label: 'Decision notification emailed',
    content:
      "We're excited you applied! Since this is a competitive program, it may take some time to get back to everyone, but we'll be in touch as soon as possible.",
  },
];

export const ApplicationUnderReview = () => {
  return (
    <ApplicationResultContent
      title="You're in! What happens next?"
      description={
        <div>
          <ApplicationResultStepper steps={steps} />
          <Button variant='primary' size='lg' additionalClassnames='w-full' href='platform/'>
            Close
          </Button>
        </div>
      }
    />
  );
};
